import Axios from "axios";
import React, { Component } from "react";
import { getUser } from "../../actions/session";
import {
  ALL_ACCOUNT_LIST,
  ALL_CARRIER_LIST,
  BILLING_CDR_URL,
  DOWNLOAD_PCAP,
  LOGIN_URL,
} from "../../config/rest_endpoints";
import Container from "../common/application_container";
import CustomLoader from "../common/loader";
import Pagination from "react-js-pagination";
import CustomModal from "../common/modal";
import Select from "react-select";
import MiniCarrierTable from "./miniCarrierTable";
import { Notifications } from "../common/notification";
import { Redirect } from "react-router-dom";
import { miniWrapText } from "../../actions/helper";
// datetime picker imports
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
// import the react-json-view component
import ReactJson from "react-json-view";
import Switch from "react-switch";
import { Tab, Tabs } from "react-bootstrap";
import { fmtDollar4, fmtMins } from '../common/formatters';

// Initializing start and end date with specific times
const utcNow = moment().utc(); // Get current UTC time
const firstDate = moment().utc().subtract(1, "hour"); // One hour before current UTC time
const lastDate = moment().utc(); // Current UTC time

// Custom tab styles using design tokens
const styles = `
  .custom-tabs .nav-link.active {
    background: linear-gradient(135deg, #10B981, #059669) !important;
    color: white !important;
    border-radius: 10px !important;
    border: none !important;
  }
  .custom-tabs .nav-link {
    color: #475569 !important;
    font-weight: 500 !important;
    font-size: 13px !important;
    border-radius: 10px !important;
    padding: 8px 20px !important;
    border: none !important;
  }
  .custom-tabs .nav-link:hover:not(.active) {
    color: #0F172A !important;
    background: #F1F5F9 !important;
  }
  .custom-tabs.nav-tabs {
    border-bottom: 1px solid #E2E8F0 !important;
    padding-bottom: 8px !important;
  }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

class CdrBilling extends Component {
  constructor(props) {
    super(props);
    // initializing states
    this.state = {
      tableData: [],
      User: getUser(),
      startDate: firstDate,
      endDate: lastDate,
      quickDatePreset: "last1h",
      exportStartDate: firstDate,
      exportEndDate: lastDate,
      isGetting: false,
      isLong: false,
      activePage: 1,
      itemsCount: 10,
      totalCount: null,
      destination: "",
      source: "",
      isCarrierModal: false,
      isStirHeaderrModal: false,
      isStirPayloadModal: false,
      isExportModal: false,
      exportFileName: "",
      carrierData: [],
      stirHeader: [],
      stirPayload: [],
      callId: "",
      isLoginURL: false,
      selectedAccount: "",
      accountOptions: [],
      selectedCarrier: "",
      carrierOptions: [],
      sourceSwitch: false,
      accountSwitch: false,
      carrierSwitch: false,
      selectedtype: { value: "all", label: "All" },
      callTypes: [
        { value: "all", label: "All" },
        { value: "successful", label: "Successfull" },
        { value: "failed", label: "Failed" },
      ],
      counter: 0,
      isBtnSpin: false,
      isDownLoadSpin: false,
      isPcapLoad: false,
      callIdx: "",
      activeTab: "cdr-search",
      exportListData: [],
      exportListPage: 1,
      exportListLimit: 10,
      exportListTotalCount: 0,
      isExportLoading: false,
      downloadingFileId: null,
    };

    this.carrierModalClose = this.carrierModalClose.bind(this);
    this.carrierModalOpen = this.carrierModalOpen.bind(this);
    // stirheader model
    this.stirHeaderModalOpen = this.stirHeaderModalOpen.bind(this);
    this.stirHeaderModalClose = this.stirHeaderModalClose.bind(this);

    this.downloadPcap = this.downloadPcap.bind(this);
    // stirpayload model
    this.stirPayloadModalOpen = this.stirPayloadModalOpen.bind(this);
    this.stirPayloadModalClose = this.stirPayloadModalClose.bind(this);

    this.handleDate = this.handleDate.bind(this);
    this.handleQuickDateSelect = this.handleQuickDateSelect.bind(this);
    this.getCdrList = this.getCdrList.bind(this);
    this.textShortness = this.textShortness.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.onHandleDestination = this.onHandleDestination.bind(this);
    this.onHandleSource = this.onHandleSource.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleExportDate = this.handleExportDate.bind(this);
    this.handleExportListPageChange =
      this.handleExportListPageChange.bind(this);
  }

  componentDidMount() {
    this.getCdrList();
    this.getAllAccount();
    this.getAllCarrier();
    this.setState({ isBtnSpin: false, isDownLoadSpin: false });
  }

  getAllAccount() {
    const { User } = this.state;

    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(ALL_ACCOUNT_LIST, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          console.log(`resp`, resp);
          const list = resp.map((row) => {
            row["label"] = row["accountName"];
            row["value"] = row["id"];
            return row;
          });
          this.setState({ accountOptions: list });
        }
      })
      .catch((err) => {
        const alert = err.response;
        console.log(`alert.data.message`, alert.data.message);
        if (alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        }
        Notifications.notify(alert.data.message, "Failed", "error");
        this.setState({
          isGetting: false,
        });
      });
  }

  getAllCarrier() {
    const { User } = this.state;
    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(ALL_CARRIER_LIST, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          console.log("responseeeeeeee", resp);
          const list = resp.map((row) => {
            row["label"] = row["name"];
            row["value"] = row["domain"];
            return row;
          });
          this.setState({ carrierOptions: list });
        }
      })
      .catch((err) => {
        const alert = err.response;
        console.log(`alert.data.message`, alert.data.message);
        if (alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        }
        Notifications.notify(alert.data.message, "Failed", "error");
        this.setState({
          isGetting: false,
        });
      });
  }

  // carrier model open
  carrierModalOpen(data, id) {
    console.log("data :>> ", data);
    this.setState({ isCarrierModal: true, carrierData: data, callId: id });
  }
  // carrier model close
  carrierModalClose() {
    this.setState({ isCarrierModal: false });
  }

  //  stirheader model open
  stirHeaderModalOpen(data, id) {
    console.log("data :>> ", data);
    this.setState({ isStirHeaderrModal: true, stirHeader: data, callId: id });
  }
  //  stirheader model close
  stirHeaderModalClose() {
    this.setState({ isStirHeaderrModal: false });
  }

  //  stirpayload model open
  stirPayloadModalOpen(data, id) {
    console.log("data :>> ", data);
    this.setState({ isStirPayloadModal: true, stirPayload: data, callId: id });
  }
  //  stirpayload model close
  stirPayloadModalClose() {
    this.setState({ isStirPayloadModal: false });
  }

  getDownloadPcap(data) {
    console.log("data", data);
    const { User } = this.state;

    // Set loading state before making the request
    this.setState({
      isPcapLoad: true,
      callIdx: data.call_id, // Use the correct property
    });

    const payload = {
      callID: data.call_id,
      startDate: data.start_date,
      duration: data.duration,
    };
    Notifications.notify(
      "It may take some time to download",
      "Downloading....",
      "info"
    );
    const headers = { Authorization: "Bearer " + User.token };

    Axios.post(`${DOWNLOAD_PCAP}`, payload, {
      headers,
      // responseType: 'blob'
    })
      .then((res) => {
        if (res) {
          console.log("response:", res);

          //*** */ For url download

          const resp = res.data.data;
          window.open(resp, "_blank");

          //*** */ For response stream data downoad
          // const response = res
          // const blob = new Blob([response.data], { type: 'application/vnd.tcpdump.pcap' });
          // const url = window.URL.createObjectURL(blob);
          // const a = document.createElement('a');
          // a.href = url;
          // a.download = `${data.call_id}.pcap`;
          // document.body.appendChild(a);
          // a.click();
          // a.remove();

          this.setState({
            isPcapLoad: false, // Stop the spinner after success
          });
        }
      })
      .catch((err) => {
        const alert = err.response;
        console.log(`alert.data.message`, alert.data.message);

        if (
          alert &&
          alert.data &&
          alert.data.message === "invalid or expired jwt"
        ) {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expired", "error");
        }

        Notifications.notify(
          alert && alert.data ? alert.data.message : "Download failed",
          "Failed",
          "error"
        );

        // Ensure spinner stops after an error
        this.setState({
          isPcapLoad: false,
          callIdx: null, // Reset the callIdx if needed
        });
      });
  }

  convertDateFormat(dateString) {
    // Create a new Date object from the input string
    const date = new Date(dateString);

    // Format year, month, day, hour, minute, and second with padding for single digits
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Return the formatted date string in the desired format
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
  }
  //  stirheader model open
  downloadPcap(time, id, dur) {
    const timeFormat = this.convertDateFormat(time);
    const payload = {
      start_date: time,
      duration: dur,
      call_id: id,
    };
    this.getDownloadPcap(payload);
    // this.setState({ isStirHeaderrModal: true, stirHeader: data, callId: id });
  }

  // handle date and time on selection of datetime picker
  handleDate(date, value) {
    console.log("date pickers", date);
    console.log("value", value);
    // const utcDate = moment.utc(date).subtract(1, 'hour');
    if (value === "start") {
      this.setState({ startDate: date, quickDatePreset: "" });
    } else {
      this.setState({ endDate: date, quickDatePreset: "" });
    }
  }

  handleQuickDateSelect(preset) {
    const now = moment().utc();
    let startDate;
    switch (preset) {
      case "last1h":
        startDate = moment().utc().subtract(1, "hour");
        break;
      case "today":
        startDate = moment().utc().startOf("day");
        break;
      case "yesterday":
        startDate = moment().utc().subtract(1, "day").startOf("day");
        now.utc().subtract(1, "day").endOf("day");
        this.setState({ startDate: startDate, endDate: moment().utc().subtract(1, "day").endOf("day"), quickDatePreset: preset });
        return;
      case "thisWeek":
        startDate = moment().utc().startOf("isoWeek");
        break;
      case "thisMonth":
        startDate = moment().utc().startOf("month");
        break;
      default:
        return;
    }
    this.setState({ startDate: startDate, endDate: now, quickDatePreset: preset });
  }

  onHandleDestination(e) {
    this.setState({ destination: e.target.value }, () => {
      console.log("search :>> ", this.state.destination);
    });
  }

  onHandleSource(e) {
    this.setState({ source: e.target.value }, () => {
      console.log("search :>> ", this.state.source);
    });
  }

  handlePageChange(pageNumber) {
    this.setState(
      {
        activePage: pageNumber,
      },
      () => {
        this.getCdrList();
      }
    );
  }

  // on filter we are getting CdrLit
  getCdrList(type) {
    console.log("type", type);
    const {
      User,
      startDate,
      endDate,
      activePage,
      itemsCount,
      destination,
      isBtnSpin,
      isDownLoadSpin,
      source,
      selectedAccount,
      selectedCarrier,
      selectedtype,
    } = this.state;
    // Convert startDate and endDate to UTC format for payload
    const startDateUTC = moment(this.state.startDate).format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    const endDateUTC = moment(this.state.endDate).format("YYYY-MM-DDTHH:mm:ss");
    console.log("first", endDateUTC, startDateUTC);

    var payLoad = {
      startDate: startDateUTC, // Get UTC timestamp
      endDate: endDateUTC,
      destination: destination,
      source: source,
      accountID: selectedAccount.value,
      carrierID: selectedCarrier.value,
      cdrType: selectedtype.value,
      // sourceOnly: this.state.sourceSwitch,
      accountOnly: this.state.accountSwitch,
      carrierOnly: this.state.carrierSwitch,
    };

    console.log("payLoad :>> ", payLoad);
    this.setState({ isGetting: true, isBtnSpin: true, isDownLoadSpin: false });
    var headers = { Authorization: "Bearer " + User.token };
    if (type === "download") {
      this.setState({
        isGetting: false,
        isBtnSpin: false,
        isDownLoadSpin: true,
      });
      Axios.post(
        `${BILLING_CDR_URL}/search/cdrs?page=${activePage}&limit=${itemsCount}&download=true`,
        payLoad,
        { headers }
      )

        .then((res) => {
          if (res) {
            var resp = res.data;
            const getFileName = res.headers["content-disposition"];
            const settingFileName = getFileName.replace(
              "attachment; filename=",
              ""
            );
            const url = window.URL.createObjectURL(new Blob([resp]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${settingFileName}.csv`);
            document.body.appendChild(link);
            Notifications.notify(
              "File is been downloading...",
              "Downloading",
              "success"
            );
            link.click();
            this.setState({
              isGetting: false,
              isBtnSpin: false,
              isDownLoadSpin: false,
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (
            alert &&
            alert.data &&
            alert.data.message === "invalid or expired jwt"
          ) {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(
            alert && alert.data ? alert.data.message : "Download failed",
            "Failed",
            "error"
          );
          this.setState({
            isGetting: false,
            isBtnSpin: false,
            isDownLoadSpin: false,
          });
        });
    } else {
      this.setState({ isGetting: true });

      Axios.post(
        `${BILLING_CDR_URL}/search/cdrs?page=${activePage}&limit=${itemsCount}`,
        payLoad,
        { headers }
      )
        .then((res) => {
          if (res) {
            const resp = res.data.data;
            console.log("result response", resp);
            console.log("result response", resp.callID);
            this.setState({
              tableData: resp,
              isGetting: false,
              isBtnSpin: false,
              isDownLoadSpin: false,
              totalCount: res.data.pageinfo.totalCount,
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (
            alert &&
            alert.data &&
            alert.data.message === "invalid or expired jwt"
          ) {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(
            alert && alert.data ? alert.data.message : "Export failed",
            "Failed",
            "error"
          );
          this.setState({
            isGetting: false,
            isBtnSpin: false,
            isDownLoadSpin: false,
          });
        });
    }
  }

  loadMoreCount() {
    this.setState({ counter: this.state.counter + 1 });
  }

  LoadMore(data) {
    const totalArray = data;

    const arraySlice = totalArray.slice(0, 10);
    console.log(`arraySlice`, arraySlice);
    this.setState({
      tableData: arraySlice,
    });
  }

  textShortness(row) {
    this.setState({
      isLong: !this.state.isLong,
    });
  }

  renderCdrsTable() {
    const { tableData, isLong } = this.state;
    console.log("tableData", tableData);
    var nullData = (
      <div className="ml-4 mt-2">
        <div
          className="dataTables_info"
          id="DataTables_Table_0_info"
          role="status"
          aria-live="polite"
        >
          Showing 0 of 0 entries
        </div>
        <div
          className="dataTables_paginate paging_simple_numbers"
          id="DataTables_Table_0_paginate"
        ></div>
      </div>
    );
    if (!tableData.length) {
      return nullData;
    } else {
      return tableData.map((row, idx) => {
        var callId = row.callID;
        return (
          <tr key={idx}>
            <td style={{ textAlign: "center" }}>{row.accountName}</td>
            <td style={{ textAlign: "center" }}>{row.setupTime}</td>
            <td style={{ textAlign: "center" }}>{row.answerTime}</td>
            <td style={{ textAlign: "center" }}>
              {row.callSetupTime === "" ? "....." : row.callSetupTime}
            </td>
            <td style={{ textAlign: "center" }}>
              {isLong ? callId : callId.substring(0, 8)}
              <i
                className="icon-menu ml-1"
                onClick={this.textShortness.bind(this, row)}
                style={{ cursor: "pointer" }}
              ></i>
            </td>
            <td style={{ textAlign: "center" }}>{row.source}</td>
            <td style={{ textAlign: "center" }}>{row.destination}</td>
            <td style={{ textAlign: "center" }}>{row.lrnDestination}</td>
            <td style={{ textAlign: "center" }}>{row.state}</td>
            <td style={{ textAlign: "center" }}>{row.fromState}</td>
            <td style={{ textAlign: "center" }}>{row.toState}</td>
            <td style={{ textAlign: "center" }}>{row.customerIP}</td>
              <td style={{ textAlign: "center" }}>{row.orig_media}</td>
            <td style={{ textAlign: "center" }}>{row.hangupCode}</td>
            <td style={{ textAlign: "center" }}>{row.hangupCause}</td>
            <td style={{ textAlign: "center" }}>{row.internalReason}</td>
            <td className="edit-button">
              {row.carriers === "" ? (
                "N/A"
              ) : (
                <i
                  className=" icon-eye-plus  "
                  style={{ fontSize: "24px" }}
                  onClick={this.carrierModalOpen.bind(
                    this,
                    row.carriers,
                    row.callID
                  )}
                ></i>
              )}
            </td>
              <td style={{ textAlign: "center" }}>{row["term_media"]}</td>
            <td style={{ textAlign: "right" }}>{row["RPM"]}</td>
            <td style={{ textAlign: "right" }}>{row["carrierRPM"]}</td>
            <td style={{ textAlign: "right" }}>{fmtMins(row.duration)}</td>
            <td style={{ textAlign: "right" }}>{row.carrierDuration}</td>
            <td style={{ textAlign: "right" }}>{fmtMins(row.billedDuration)}</td>
            <td style={{ textAlign: "right" }}>{fmtMins(row.carrierBilledDuration)}</td>
            <td style={{ textAlign: "right" }}>{fmtDollar4(row.billed)}</td>
            <td style={{ textAlign: "right" }}>{fmtDollar4(row.paid)}</td>
            <td style={{ textAlign: "right" }}>{fmtDollar4(row.profit)}</td>
            <td className="edit-button">
              {row.stirHeader === "" ? (
                "N/A"
              ) : (
                <i
                  className=" icon-eye-plus  icon-1x"
                  style={{ fontSize: "24px" }}
                  onClick={this.stirHeaderModalOpen.bind(
                    this,
                    row.stirHeader,
                    row.callID
                  )}
                ></i>
              )}
            </td>

            {/* <td className="edit-button">
              {row.stirPayload === "" ? (
                "N/A"
              ) : (
                <i
                  className=" icon-eye-plus  icon-2x"
                  onClick={this.stirPayloadModalOpen.bind(
                    this,
                    row.stirPayload,
                    row.callID
                  )}
                ></i>
              )}
            </td> */}
            <td className="edit-button">
              {this.state.isPcapLoad && row.callID === this.state.callIdx ? (
                <i
                  className="icon-spinner4 spinner icon-1x"
                  style={{ fontSize: "24px" }}
                ></i>
              ) : (
                <i
                  className="icon-download7 icon-1x"
                  style={{ cursor: "pointer", fontSize: "24px" }}
                  onClick={() =>
                    this.downloadPcap(row.setupTime, row.callID, row.duration)
                  }
                ></i>
              )}
            </td>
          </tr>
        );
      });
    }
  }

  downloadAllResult() {}

  // Add new handler for switches
  handleSwitchChange = (switchName) => {
    this.setState((prevState) => ({
      [switchName]: !prevState[switchName],
    }));
  };

  // Add tab change handler
  handleTabChange = (key) => {
    this.setState({ activeTab: key }, () => {
      // If switching to export-list tab, automatically call the filter function without loader
      if (key === "export-list") {
        this.getExportListData(false); // Pass false to not show loader
      }
    });
  };

  // Add new handler for export list dates
  handleExportDate(date, value) {
    if (value === "start") {
      this.setState({ exportStartDate: date });
    } else {
      this.setState({ exportEndDate: date });
    }
  }

  // Add new function to handle export list pagination
  handleExportListPageChange = (pageNumber) => {
    this.setState({ exportListPage: pageNumber }, () => {
      this.handleExportListDownload();
    });
  };

  // Add new function to get export list data
  getExportListData = (showLoader = true) => {
    const {
      User,
      exportStartDate,
      exportEndDate,
      exportListPage,
      exportListLimit,
    } = this.state;

    // Convert dates to UTC format
    const startDateUTC = moment(exportStartDate).format("YYYY-MM-DDTHH:mm:ss");
    const endDateUTC = moment(exportEndDate).format("YYYY-MM-DDTHH:mm:ss");

    const payLoad = {
      startDate: startDateUTC,
      endDate: endDateUTC,
      page: exportListPage,
      limit: exportListLimit,
    };

    if (showLoader) {
      this.setState({ isDownLoadSpin: true });
    }

    var headers = { Authorization: "Bearer " + User.token };

    Axios.post(`${BILLING_CDR_URL}/export/cdrs/list`, payLoad, { headers })
      .then((res) => {
        if (res && res.status === 200) {
          console.log("response", res.data);
          this.setState({
            exportListData: res.data.data,
            exportListTotalCount: res.data.pageinfo.totalCount,
            isDownLoadSpin: false,
          });
        }
      })
      .catch((err) => {
        const alert = err.response;
        if (
          alert &&
          alert.data &&
          alert.data.message === "invalid or expired jwt"
        ) {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        }
        this.setState({ isDownLoadSpin: false });
      });
  };

  // Modify handleExportListDownload to use the new function
  handleExportListDownload = () => {
    this.getExportListData(true); // Pass true to show loader
  };

  // Add function to render export list table
  renderExportListTable = () => {
    const { exportListData, isDownLoadSpin, downloadingFileId } = this.state;

    const getStatusBadgeClass = (status) => {
      switch (status.toLowerCase()) {
        case "completed":
          return "badge badge-success";
        case "in progress":
          return "badge badge-warning";
        case "failed":
          return "badge badge-danger";
        default:
          return "badge badge-secondary";
      }
    };

    return (
      <div
        className="datatable-scroll"
        style={{ overflowX: "auto", overflowY: "auto", maxHeight: "56em" }}
      >
        <table className="table-style table table-striped dataTable no-footer">
          <thead>
            <tr className="stickeyHeader table-heading-style">
              <th>Create Date</th>
              <th>Account Name</th>
              <th>Carrier Name</th>
              <th>Source</th>
              <th>Destination</th>
              <th>CDR Type</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>File Name</th>
              <th>Status</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {isDownLoadSpin ? (
              <CustomLoader />
            ) : exportListData.length === 0 ? (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  <div
                    className="dataTables_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing 0 of 0 entries
                  </div>
                </td>
              </tr>
            ) : (
              exportListData.map((row, idx) => (
                <tr key={idx}>
                  <td style={{ textAlign: "center" }}>
                    {moment(row.createDate).format("YYYY-MM-DD HH:mm:ss")}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {row.accountName || "N/A"}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {row.carrierName || "N/A"}
                  </td>
                  <td style={{ textAlign: "center" }}>{row.source || "N/A"}</td>
                  <td style={{ textAlign: "center" }}>
                    {row.destination || "N/A"}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {row.cdrType || "N/A"}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {moment(row.startDate).format("YYYY-MM-DD HH:mm:ss")}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {moment(row.endDate).format("YYYY-MM-DD HH:mm:ss")}
                  </td>
                  <td style={{ textAlign: "center" }}>{row.fileID || "N/A"}</td>
                  <td style={{ textAlign: "center" }}>
                    <span className={getStatusBadgeClass(row.status)}>
                      {row.status || "Pending"}
                    </span>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {downloadingFileId === row.fileID ? (
                      <i
                        className="icon-spinner4 spinner"
                        style={{ fontSize: "18px" }}
                      ></i>
                    ) : (
                      <i
                        className={`icon-download7 ${
                          row.status === "completed"
                            ? "text-dark"
                            : "text-muted"
                        }`}
                        style={{
                          cursor:
                            row.status === "completed"
                              ? "pointer"
                              : "not-allowed",
                          fontSize: "18px",
                          opacity: row.status === "completed" ? 1 : 0.5,
                        }}
                        onClick={() =>
                          row.status === "completed" &&
                          row.fileID &&
                          this.handleExportDownload(row.fileID)
                        }
                      ></i>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  };

  // Add new function to handle export download
  handleExportDownload = (row) => {
    console.log("row", row);
    const { User } = this.state;
    const headers = { Authorization: "Bearer " + User.token };

    this.setState({ downloadingFileId: row }); // Set the downloading file ID

    Axios.get(`${BILLING_CDR_URL}/export/cdrs/download/${row}`, {
      headers,
      responseType: "blob",
    })
      .then((res) => {
        console.log("res", res);
        const fileBlob = new Blob([res.data], { type: "application/gzip" });
        const fileURL = window.URL.createObjectURL(fileBlob);
        // window.open(res.config.url, "_blank");
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", `CDR-${row}.csv.gz`); // Customize filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Notifications.notify(
          "File downloaded sucessfully",
          "Success",
          "success"
        );
      })
      .catch((err) => {
        const alert = err.response;
        if (alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        } else {
          Notifications.notify(
            alert.data.message || "Open failed",
            "Failed",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({ downloadingFileId: null }); // Reset the downloading file ID
      });
  };

  // Add these new methods after the existing modal methods
  openExportModal = () => {
    this.setState({ isExportModal: true });
  };

  closeExportModal = () => {
    this.setState({ isExportModal: false, exportFileName: "" });
  };

  handleExportFileNameChange = (e) => {
    this.setState({ exportFileName: e.target.value });
  };

  handleExport = () => {
    const {
      User,
      exportFileName,
      startDate,
      endDate,
      destination,
      source,
      selectedAccount,
      selectedCarrier,
      selectedtype,
      accountSwitch,
      carrierSwitch,
    } = this.state;

    // Convert dates to UTC format
    const startDateUTC = moment(startDate).format("YYYY-MM-DDTHH:mm:ss");
    const endDateUTC = moment(endDate).format("YYYY-MM-DDTHH:mm:ss");

    const payload = {
      fileName: exportFileName,
      startDate: startDateUTC,
      endDate: endDateUTC,
      destination: destination,
      source: source,
      accountID: selectedAccount.value,
      carrierID: selectedCarrier.value,
      cdrType: selectedtype.value,
      accountOnly: accountSwitch,
      carrierOnly: carrierSwitch,
    };

    this.setState({ isExportLoading: true });
    const headers = { Authorization: "Bearer " + User.token };

    Axios.post(`${BILLING_CDR_URL}/export/cdrs`, payload, { headers })
      .then((res) => {
        if (res && res.status === 200) {
          Notifications.notify(
            "Export request submitted successfully",
            "Success",
            "success"
          );
          this.closeExportModal();
          // Refresh the export list if we're on that tab
          if (this.state.activeTab === "export-list") {
            this.getExportListData(false);
          }
        }
      })
      .catch((err) => {
        const alert = err.response;
        if (alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        } else {
          Notifications.notify(
            alert.data.message || "Export failed",
            "Failed",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({ isExportLoading: false });
      });
  };

  render() {
    const {
      startDate,
      endDate,
      isGetting,
      activePage,
      itemsCount,
      totalCount,
      isCarrierModal,
      isStirHeaderrModal,
      isStirPayloadModal,
      isExportModal,
      exportFileName,
      selectedAccount,
      accountOptions,
      selectedCarrier,
      carrierOptions,
      callTypes,
      selectedtype,
      isBtnSpin,
      isDownLoadSpin,
    } = this.state;
    console.log(`selectedAccount`, selectedAccount);

    const wrappedCallId = miniWrapText(this.state.callId);
    // console.log("wrappedCallId",wrappedCallId);

    // carrier model
    let carrierTable = {
      details: {
        info: (
          <h6>
            <b>Call ID :</b> {wrappedCallId}
          </h6>
        ),
        msg: <MiniCarrierTable table={this.state.carrierData} />,
      },
      confirmBtn: { label: "Update", action: "" },
      crossBtn: { action: this.carrierModalClose },
      cancelBtn: { label: "Cancel", action: this.carrierModalClose },
    };
    // stirheader model
    let stirHeaderModel = {
      details: {
        info: (
          <h6>
            <b>Call ID :</b> {wrappedCallId}
          </h6>
        ),
        msg: (
          <div className="p-2" style={{ overflowX: "auto" }}>
            <ReactJson
              src={{
                "STIR Header": this.state.stirHeader,
              }}
            />
          </div>
        ),
      },
      confirmBtn: { label: "Update", action: "" },
      crossBtn: { action: this.stirHeaderModalClose },
      cancelBtn: { label: "Cancel", action: this.stirHeaderModalClose },
    };
    // stirpayload model
    let stirPayloadModel = {
      details: {
        info: (
          <h6>
            <b>Call ID :</b> {wrappedCallId}
          </h6>
        ),
        msg: (
          <div className="p-2">
            <ReactJson
              src={{
                "STIR Header": this.state.stirPayload,
              }}
            />
          </div>
        ),
      },
      confirmBtn: { label: "Update", action: "" },
      crossBtn: { action: this.stirPayloadModalClose },
      cancelBtn: { label: "Cancel", action: this.stirPayloadModalClose },
    };
    // export modal
    const exportModal = {
      details: {
        info: "Export CDR",
        msg: (
          <div>
            <div className="form-group">
              <label htmlFor="fileName">File Name *</label>
              <input
                type="text"
                className="form-control"
                id="fileName"
                value={exportFileName}
                onChange={this.handleExportFileNameChange}
                placeholder="Enter file name"
              />
            </div>
            <div className="row" style={{ borderTop: "1px solid #e9ecef" }}>
              <div className="col-md-12">
                <button
                  type="submit"
                  className="main-button mt-2 btn btn-primary btn-sm float-right"
                  onClick={this.handleExport}
                  disabled={!exportFileName || this.state.isExportLoading}
                >
                  Export{" "}
                  <i
                    className={`${
                      this.state.isExportLoading
                        ? "icon-spinner4 spinner"
                        : "icon-download7"
                    } ml-2`}
                  ></i>
                </button>
              </div>
            </div>
          </div>
        ),
      },
      crossBtn: { action: this.closeExportModal },
    };
    if (this.state.isLoginURL === true) {
      return <Redirect to={LOGIN_URL}></Redirect>;
    }
    return (
      <Container title="CDRs" title1="Table" icon="fa fa-credit-card">
        {/* Add Export Modal */}
        <CustomModal
          visibility={isExportModal}
          modalType={"success"}
          details={exportModal.details}
          showBtns={false}
          confirmBtn={exportModal.confirmBtn}
          cancelBtn={exportModal.cancelBtn}
          crossBtn={exportModal.crossBtn}
        />

        {/* Tabs */}
        <Tabs
          activeKey={this.state.activeTab}
          onSelect={this.handleTabChange}
          className="mb-3 custom-tabs"
        >
          <Tab eventKey="cdr-search" title="CDR Search">
            <div
              style={{
                border: "1px solid #E2E8F0",
                borderRadius: "16px",
                background: "#FFFFFF",
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                overflow: "hidden",
                padding: "20px",
              }}
            >
              {/* carrier model */}
              <CustomModal
                visibility={isCarrierModal}
                modalType={"success"}
                details={carrierTable.details}
                showBtns={false}
                cancelBtn={carrierTable.cancelBtn}
                crossBtn={carrierTable.crossBtn}
              />
              {/* stir header model */}
              <CustomModal
                modalSize={"large"}
                visibility={isStirHeaderrModal}
                modalType={"success"}
                details={stirHeaderModel.details}
                showBtns={false}
                cancelBtn={stirHeaderModel.cancelBtn}
                crossBtn={stirHeaderModel.crossBtn}
              />
              {/* stir payload model */}
              <CustomModal
                visibility={isStirPayloadModal}
                modalType={"success"}
                details={stirPayloadModel.details}
                showBtns={false}
                cancelBtn={stirPayloadModel.cancelBtn}
                crossBtn={stirPayloadModel.crossBtn}
              />

              {/* Date Range Section with Download CSV */}
              <div style={{background:'#F8FAFC',borderRadius:'12px',border:'1px solid #E2E8F0',padding:'16px 20px',marginBottom:'16px'}}>
                <div style={{display:'flex',flexWrap:'wrap',gap:'6px',marginBottom:'12px'}}>
                  {[
                    { key: "last1h", label: "Last 1 Hour" },
                    { key: "today", label: "Today" },
                    { key: "yesterday", label: "Yesterday" },
                    { key: "thisWeek", label: "This Week" },
                    { key: "thisMonth", label: "This Month" },
                  ].map((item) => (
                    <button
                      key={item.key}
                      type="button"
                      onClick={() => this.handleQuickDateSelect(item.key)}
                      style={{
                        background: this.state.quickDatePreset === item.key ? "linear-gradient(135deg, #10B981, #059669)" : "#fff",
                        color: this.state.quickDatePreset === item.key ? "#fff" : "#475569",
                        border: this.state.quickDatePreset === item.key ? "1px solid transparent" : "1px solid #E2E8F0",
                        borderRadius: "8px",
                        padding: "5px 14px",
                        fontSize: "12px",
                        fontWeight: "500",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
                <div style={{display:'flex',flexWrap:'wrap',justifyContent:'space-between',alignItems:'center'}}>
                  <div style={{display:'flex',flexWrap:'wrap',gap:'16px'}}>
                    <div style={{paddingTop:'8px',paddingBottom:'8px'}}>
                      <div>
                        <label
                          style={{ fontWeight: "500", fontSize: "13px", color: "#475569", marginBottom: "6px", display: "block" }}
                        >
                          Start Date
                        </label>
                        <div className="input-group">
                          <DateRangePicker
                            key={"start-" + moment(this.state.startDate).valueOf()}
                            initialSettings={{
                              singleDatePicker: true,
                              timePicker: true,
                              showDropdowns: true,
                              startDate: this.state.startDate,
                              locale: {
                                format: "MMMM/DD/YYYY h:mm A",
                              },
                              timeZone: "UTC",
                            }}
                            onCallback={(start) =>
                              this.handleDate(start, "start")
                            }
                          >
                            <input
                              type="text"
                              className="form-control"
                              style={{ minWidth: "250px" }}
                            />
                          </DateRangePicker>
                        </div>
                      </div>
                    </div>
                    <div style={{paddingTop:'8px',paddingBottom:'8px'}}>
                      <div>
                        <label
                          style={{ fontWeight: "500", fontSize: "13px", color: "#475569", marginBottom: "6px", display: "block" }}
                        >
                          End Date
                        </label>
                        <div className="input-group">
                          <DateRangePicker
                            key={"end-" + moment(this.state.endDate).valueOf()}
                            initialSettings={{
                              singleDatePicker: true,
                              timePicker: true,
                              showDropdowns: true,
                              startDate: this.state.endDate,
                              locale: {
                                format: "MMMM/DD/YYYY h:mm A",
                              },
                              timeZone: "UTC",
                            }}
                            onCallback={(endDate) =>
                              this.handleDate(endDate, "end")
                            }
                          >
                            <input
                              type="text"
                              className="form-control"
                              style={{ minWidth: "250px" }}
                            />
                          </DateRangePicker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", alignItems: "flex-end", gap: "8px", paddingBottom: "8px" }}
                  >
                    <button
                      type="button"
                      style={{background:'#fff',color:'#475569',border:'1px solid #E2E8F0',borderRadius:'10px',padding:'8px 18px',fontSize:'13px',fontWeight:'500',cursor:'pointer'}}
                      onClick={this.openExportModal}
                    >
                      Export{" "}
                      <i
                        className={`${
                          isDownLoadSpin
                            ? "icon-spinner4 spinner"
                            : "icon-download7"
                        } ml-2`}
                      ></i>
                    </button>
                    <button
                      type="button"
                      style={{background:'linear-gradient(135deg, #10B981, #059669)',color:'#fff',border:'none',borderRadius:'10px',padding:'8px 18px',fontSize:'13px',fontWeight:'500',cursor:'pointer',boxShadow:'0 2px 8px rgba(16,185,129,0.25)'}}
                      onClick={this.getCdrList.bind(this, "download")}
                    >
                      Download CSV{" "}
                      <i
                        className={`${
                          isDownLoadSpin
                            ? "icon-spinner4 spinner"
                            : "icon-download7"
                        } ml-2`}
                      ></i>
                    </button>
                  </div>
                </div>
              </div>

              {/* Combined Filter Section */}
              <div style={{background:'#F8FAFC',borderRadius:'12px',border:'1px solid #E2E8F0',padding:'16px 20px',marginBottom:'20px'}}>
                {/* Filter Controls Section */}
                <div
                  style={{display:'flex',justifyContent:'flex-start',flexWrap:'wrap',gap:'16px',zIndex:'1',position:'relative'}}
                >
                  <div>
                    <div>
                      <label
                        style={{ fontWeight: "500", fontSize: "13px", color: "#475569", marginBottom: "6px", display: "block" }}
                      >
                        Source{" "}
                      </label>
                      <div className="input-group w-20em">
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.source}
                          onChange={this.onHandleSource}
                          placeholder="Type source"
                          style={{ minWidth: "290px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <label
                        style={{ fontWeight: "500", fontSize: "13px", color: "#475569", marginBottom: "6px", display: "block" }}
                      >
                        Destination{" "}
                      </label>
                      <div className="input-group w-20em">
                        <input
                          type="text"
                          className="form-control"
                          value={this.state.destination}
                          onChange={this.onHandleDestination}
                          placeholder="Type destination"
                          style={{ minWidth: "290px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <div>
                      <label
                        style={{ fontWeight: "500", fontSize: "13px", color: "#475569", marginBottom: "6px", display: "block" }}
                      >
                        Account Select
                      </label>
                      <Select
                        value={selectedAccount}
                        onChange={(selectedAccount) =>
                          this.setState({ selectedAccount })
                        }
                        options={accountOptions}
                        className="w-20em"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minWidth: "290px",
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div>
                      <label
                        style={{ fontWeight: "500", fontSize: "13px", color: "#475569", marginBottom: "6px", display: "block" }}
                      >
                        Call Type
                      </label>
                      <Select
                        value={selectedtype}
                        onChange={(selectedtype) =>
                          this.setState({ selectedtype })
                        }
                        options={callTypes}
                        className="w-20em"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minWidth: "290px",
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div>
                      <label
                        style={{ fontWeight: "500", fontSize: "13px", color: "#475569", marginBottom: "6px", display: "block" }}
                      >
                        Carrier Select
                      </label>
                      <Select
                        value={selectedCarrier}
                        onChange={(selectedCarrier) =>
                          this.setState({ selectedCarrier })
                        }
                        options={carrierOptions}
                        className="w-20em"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minWidth: "290px",
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Toggle Switches Section - Left Aligned */}
                <div style={{display:'flex',alignItems:'center',marginTop:'16px',marginBottom:'16px',gap:'24px'}}>
                  <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                    <span style={{ fontSize: "13px", color: "#475569", fontWeight: "500" }}>
                      Account Only:
                    </span>
                    <Switch
                      onChange={() => this.handleSwitchChange("accountSwitch")}
                      checked={this.state.accountSwitch}
                      onColor="#10B981"
                      height={20}
                      width={40}
                    />
                  </div>
                  <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                    <span style={{ fontSize: "13px", color: "#475569", fontWeight: "500" }}>
                      Carrier Only:
                    </span>
                    <Switch
                      onChange={() => this.handleSwitchChange("carrierSwitch")}
                      checked={this.state.carrierSwitch}
                      onColor="#10B981"
                      height={20}
                      width={40}
                    />
                  </div>
                </div>

                {/* Action Buttons - Right Aligned at Bottom */}
                <div style={{display:'flex',justifyContent:'flex-end',marginTop:'12px'}}>
                    <button
                      type="button"
                      style={{background:'linear-gradient(135deg, #10B981, #059669)',color:'#fff',border:'none',borderRadius:'10px',padding:'8px 20px',fontSize:'13px',fontWeight:'500',cursor:'pointer',boxShadow:'0 2px 8px rgba(16,185,129,0.25)'}}
                      onClick={this.getCdrList}
                    >
                      Filter{" "}
                      <i
                        className={`${
                          isBtnSpin
                            ? "icon-spinner4 spinner"
                            : "icon-arrow-right8"
                        } ml-2`}
                      ></i>
                    </button>
                </div>
              </div>

              {/* Table Section */}
              <div style={{ zIndex: "0" }}>
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "56em",
                    borderRadius: "12px",
                    border: "1px solid #E2E8F0",
                  }}
                >
                  <table
                    className="table table-striped"
                    style={{ margin: 0 }}
                  >
                    <thead>
                      <tr style={{ position: "sticky", top: 0, zIndex: "1" }}>
                        <th>Account</th>
                        <th>Setup Time</th>
                        <th>Answer Time</th>
                        <th>Call Setup Time</th>
                        <th>Call ID</th>
                        <th>Source</th>
                        <th>Destination</th>
                        <th>Destination LRN</th>
                        <th>Jurisdiction</th>
                        <th>From State</th>
                        <th>To State</th>
                        <th>Customer Ip</th>
                          <th>Customer Media</th>
                        <th>Hangup Code</th>
                        <th>Hangup Cause</th>
                        <th>Internal Reason</th>
                        <th>Carriers</th>
                          <th>Carrier Media</th>
                        <th style={{textAlign:'right'}}>RPM</th>
                        <th style={{textAlign:'right'}}>Carrier RPM</th>
                        <th style={{textAlign:'right'}}>Duration</th>
                        <th style={{textAlign:'right'}}>Carrier Duration</th>
                        <th style={{textAlign:'right'}}>Billed Duration</th>
                        <th style={{textAlign:'right'}}>Carrier Billed Duration</th>
                        <th style={{textAlign:'right'}}>Revenue</th>
                        <th style={{textAlign:'right'}}>Cost</th>
                        <th style={{textAlign:'right'}}>Profit</th>
                        <th>Stir Header</th>
                        <th>Pcap</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isGetting ? <CustomLoader /> : this.renderCdrsTable()}
                    </tbody>
                  </table>
                </div>
                {totalCount >= 9 ? (
                  <div style={{padding:'12px 0',marginTop:'8px'}}>
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={itemsCount}
                      totalItemsCount={totalCount}
                      pageRangeDisplayed={5}
                      onChange={this.handlePageChange.bind(this)}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Tab>
          <Tab eventKey="export-list" title="Export List">
            <div
              style={{
                border: "1px solid #E2E8F0",
                borderRadius: "16px",
                background: "#FFFFFF",
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                overflow: "hidden",
                padding: "20px",
              }}
            >
              <div style={{background:'#F8FAFC',borderRadius:'12px',border:'1px solid #E2E8F0',padding:'16px 20px',marginBottom:'16px',display:'flex',flexWrap:'wrap',gap:'16px',alignItems:'flex-end'}}>
                <div>
                  <div>
                    <label
                      style={{ fontWeight: "500", fontSize: "13px", color: "#475569", marginBottom: "6px", display: "block" }}
                    >
                      Start Date
                    </label>
                    <div>
                      <DateRangePicker
                        initialSettings={{
                          singleDatePicker: true,
                          timePicker: true,
                          showDropdowns: true,
                          startDate: this.state.exportStartDate,
                          locale: {
                            format: "MMMM/DD/YYYY h:mm A",
                          },
                          timeZone: "UTC",
                        }}
                        onCallback={(start) =>
                          this.handleExportDate(start, "start")
                        }
                      >
                        <input
                          type="text"
                          className="form-control"
                          style={{ minWidth: "300px" }}
                        />
                      </DateRangePicker>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <label
                      style={{ fontWeight: "500", fontSize: "13px", color: "#475569", marginBottom: "6px", display: "block" }}
                    >
                      End Date
                    </label>
                    <div>
                      <DateRangePicker
                        initialSettings={{
                          singleDatePicker: true,
                          timePicker: true,
                          showDropdowns: true,
                          startDate: this.state.exportEndDate,
                          locale: {
                            format: "MMMM/DD/YYYY h:mm A",
                          },
                          timeZone: "UTC",
                        }}
                        onCallback={(endDate) =>
                          this.handleExportDate(endDate, "end")
                        }
                      >
                        <input
                          type="text"
                          className="form-control"
                          style={{ minWidth: "300px", borderRadius: "8px", border: "1px solid #E2E8F0", fontSize: "13px" }}
                        />
                      </DateRangePicker>
                    </div>
                  </div>
                </div>
                <div>
                    <button
                      type="button"
                      style={{background:'linear-gradient(135deg, #10B981, #059669)',color:'#fff',border:'none',borderRadius:'10px',padding:'8px 20px',fontSize:'13px',fontWeight:'500',cursor:'pointer',boxShadow:'0 2px 8px rgba(16,185,129,0.25)'}}
                      onClick={this.handleExportListDownload}
                      disabled={isDownLoadSpin}
                    >
                      Filter{" "}
                      <i
                        className={`${
                          isDownLoadSpin
                            ? "icon-spinner4 spinner"
                            : "icon-arrow-right8"
                        } ml-2`}
                      ></i>
                    </button>
                </div>
              </div>

              {/* Export List Table */}
              <div className="mt-3">
                {this.renderExportListTable()}
                {this.state.exportListTotalCount > 0 && (
                  <div className="datatable-footer mt-1">
                    <Pagination
                      activePage={this.state.exportListPage}
                      itemsCountPerPage={this.state.exportListLimit}
                      totalItemsCount={this.state.exportListTotalCount}
                      pageRangeDisplayed={5}
                      onChange={this.handleExportListPageChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </Tab>
        </Tabs>
      </Container>
    );
  }
}
export default CdrBilling;
